<template>
    <v-dialog v-model="show" width="800">
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>{{ t("common", "STR_IMAGE") }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon dark @click.stop="show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text>
                <v-progress-circular v-if="loading" indeterminate color="primary" class="d-block mx-auto my-4" />

                <v-carousel v-if="!loading && images.length > 0" cycle hide-delimiters
                    :show-arrows="images.length > 1 ? 'hover' : false">
                    <v-carousel-item v-for="(img, index) in images" :key="index">

                        <v-img :src="img.link" contain height="400px"></v-img>
                        <div class="image-caption">
                            <strong>{{ img.dat }}</strong><br /> {{ img.bez }}<br />

                        </div>
                    </v-carousel-item>
                </v-carousel>

                <p v-if="!loading && images.length === 0" class="text-center">
                    {{ t("common", "STR_NO_IMAGE_AVAILABLE") }}
                </p>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.stop="show = false">{{ t("common", "STR_CLOSE") }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.image-caption {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.6);
    /* Halbtransparent */
    color: white;
    text-align: center;
    padding: 8px;

}
</style>

<script>
import axios from "axios";

export default {
    props: {
        anr: String,
        baupid: String,
        bcstid: String,
        type: String,
        value: Boolean
    },
    data() {
        return {
            images: [],
            loading: false
        };
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            }
        }
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.loadImages();
            }
        }
    },
    methods: {
        /**
        * Loads images based on the given component parameters or the associated identifiers.
        */
        loadImages() {
            if (!this.anr) return;

            this.loading = true;
            this.images = [];
            let params = {
                opcode: "L",
                format: "J",
                anr: this.anr,
                art: this.type
            }
            if (this.bcstid) {
                params.bcstid = this.bcstid;
            }
            if (this.baupid) {
                params.baupid = this.baupid;
            }

            axios
                .get(process.env.VUE_APP_BACKEND_IMAGES, {
                    params: params,
                    withCredentials: true
                })
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        this.images = response.data.map(img => ({
                            link: process.env.VUE_APP_BACKEND_IMAGES + img.link,
                            dat: img.dat,
                            bez: img.bez
                        }));
                    } else {
                        this.$store.dispatch("showMessage", {
                            type: "Error",
                            text: "No images found"
                        });
                    }
                })
                .catch(error => {
                    this.$store.dispatch("showMessage", {
                        type: "Error",
                        text: error.message
                    });
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

    }
};
</script>
